var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('v-card',_vm._b({},'v-card',_vm.$attrs,false),[_c('v-system-bar',[_vm._v("Schule")]),_c('v-list',{attrs:{"subheader":""}},[_c('ListItem',{attrs:{"title":"Telefon Schule"}},[_c('PhoneNumber',{attrs:{"value":_vm.info.phoneSchool}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }